"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigationCardIds = void 0;
// Card ids.
exports.navigationCardIds = {
    ACCEPT_DEAL_CARD_ID: 'dr-sp-accept-offer-card',
    CREDIT_APP_CARD_ID: 'dr-sp-credit-app-card',
    MENU_CARD_ID: 'dr-sp-menu-card',
    MESSAGING_BUTTON_CARD_ID: 'dr-sp-messaging-button',
    NO_CARD_ID: 'dr-sp-no-card',
    PENCIL_CARD_ID: 'dr-sp-pencil-card',
    RESERVATION_CARD_ID: 'dr-sp-vehicle-reservation-card',
    TEST_DRIVE_CARD_ID: 'dr-sp-test-drive-card',
    TRADE_IN_APP_CARD_ID: 'dr-sp-trade-in-card',
    INCENTIVES_CARD_ID: 'dr-sp-incentives-card',
    DEALER_OFFER_CARD_ID: 'dr-sp-dealer-offer-card',
    DOCUMENT_UPLOAD_ID: 'dr-sp-document-upload-card'
};
